import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles.css';

function InputModern({
  disabled,
  isEditable,
  form,
  field,
  placeholder,
  maxLength,
  autoFocus,
  testID,
  formatValue,
  defaultValue,
  normalize,
  autocomplete,
}) {
  const { touched, warning, errors } = form;
  const showError = touched && errors[field.name];
  const hasValue = field.value && field.value !== null;
  const showWarning = !showError && warning;
  
  if (isEditable === false) {
    return (
      <div className={styles.value}>{formatValue(field.value) || '-'}</div>
    );
  }
  const handleChange = (e) => {
    const val = e && e.target ? e.target.value : e;
    form.setFieldValue(field.name, normalize ? normalize(val) : val);
  };

  return (
    <React.Fragment>
      <input
        {...field}
        id={name}
        name={name}
        maxLength={maxLength}
        className="form-control"
        disabled={disabled}
        placeholder={placeholder}
        autoFocus={autoFocus} // eslint-disable-line
        data-testid={testID}
        onChange={handleChange}
        autoComplete={autocomplete}
      />
      { showError && (
        <span
          style={{ color: 'red', fontSize: '10px' }}
        >
          { errors[field.name] }
        </span>
      )}
    </React.Fragment>
  );
}

InputModern.defaultProps = {
  placeholder: '',
  disabled: false,
  isEditable: true,
  maxLength: undefined,
  autoFocus: false,
  testID: undefined,
  formatValue: (value) => value,
  defaultValue: '',
  autocomplete: undefined,
  normalize: (value) => value,
};

InputModern.propTypes = {
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool,
  testID: PropTypes.string,
  formatValue: PropTypes.func,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  autocomplete: PropTypes.string,
  normalize: PropTypes.func,
};

export default InputModern;
